import { defineCustomElement } from '@tyler-components-web/core';
import { IconButtonComponent } from './icon-button';
export * from './icon-button-constants';
export * from './icon-button';
export function defineIconButtonComponent() {
    defineCustomElement(IconButtonComponent);
}
